module.exports = __webpack_public_path__ + "img/item-1(1920).de532271.jpg";